import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useNavigationContainerRef } from '../../Hooks/UseNavigatorRef';
import { addRoutes, removeRoutes } from '../../Hooks/UseRouteParams';
import { HeaderButtonView } from './HeaderButtonView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { CoreScreens } from '../../Constants/CoreScreens';
import { CoreRoutes } from '../../Coordinator/Coordinator/CoreRoutes';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
const Stack = createNativeStackNavigator();
function getNavigation(type = 'stack') {
    const navigators = {
        stack: Stack,
    };
    if (!navigators[type]) {
        return navigators.stack;
    }
    return navigators[type];
}
let count = 0;
export const NavigatorView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.navigator,
    style(theme, mediaQuery, window, props) {
        var _a, _b, _c;
        return {
            header: {
                backgroundColor: (_c = (_b = (_a = theme.layouts) === null || _a === void 0 ? void 0 : _a.base_screen) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.backgroundColor
            }
        };
    }
})(({ type, screens, navigatorOptions, style, getAppConfigurationUseCase }) => {
    const Navigation = getNavigation(type);
    const [navigationRef] = useNavigationContainerRef();
    const isFirst = useRef(count === 0);
    const onDismiss = useCallback(() => navigationRef === null || navigationRef === void 0 ? void 0 : navigationRef.goBack(), [navigationRef]);
    const currentScreens = useMemo(() => {
        let updatedScreens = [...screens, ...CoreScreens];
        if (!isFirst.current) {
            updatedScreens = updatedScreens.filter(x => x.name !== CoreRoutes.appUpdate);
        }
        return updatedScreens
            .reduce((acc, screen) => {
            var _a, _b, _c, _d, _e;
            if (acc.find(x => x.name === screen.name)) {
                return acc;
            }
            const newScreen = Object.assign(Object.assign({}, screen), { options: Object.assign(Object.assign({ title: Platform.OS === 'web'
                        ? ((_c = (_b = (_a = getAppConfigurationUseCase === null || getAppConfigurationUseCase === void 0 ? void 0 : getAppConfigurationUseCase.configuration.value) === null || _a === void 0 ? void 0 : _a.meta_properties) === null || _b === void 0 ? void 0 : _b.share) === null || _c === void 0 ? void 0 : _c.title) ||
                            ((_d = getAppConfigurationUseCase === null || getAppConfigurationUseCase === void 0 ? void 0 : getAppConfigurationUseCase.configuration.value) === null || _d === void 0 ? void 0 : _d.brand_name) ||
                            document.title
                        : '', headerStyle: {
                        backgroundColor: (_e = style === null || style === void 0 ? void 0 : style.header) === null || _e === void 0 ? void 0 : _e.backgroundColor
                    }, headerLeft: (props) => _jsx(HeaderButtonView, Object.assign({}, props, { onPress: onDismiss })) }, Platform.select({
                    web: {
                        customAnimationOnGesture: true,
                        animation: 'fade'
                    }
                })), screen.options) });
            if (Platform.OS === 'android' && !newScreen.options.animation) {
                newScreen.options.animation = 'fade';
            }
            if (newScreen.options.presentation === 'transparentModal' || newScreen.options.presentation === 'fullScreenModal') {
                if (newScreen.options.headerShown === undefined) {
                    newScreen.options.headerShown = false;
                }
                if (newScreen.options.animation === undefined) {
                    newScreen.options.animation = 'fade';
                }
                acc.push(newScreen);
                return acc;
            }
            acc.push(newScreen);
            return acc;
        }, []);
    }, [screens]);
    const screenOptions = useMemo(() => {
        return Object.assign({ headerShadowVisible: false }, navigatorOptions === null || navigatorOptions === void 0 ? void 0 : navigatorOptions.screenOptions);
    }, [navigatorOptions]);
    useEffect(() => {
        count++;
        return () => {
            count--;
        };
    }, []);
    useEffect(() => {
        addRoutes(currentScreens);
        return () => {
            removeRoutes(currentScreens);
        };
    }, [currentScreens]);
    return (_jsx(Navigation.Navigator, Object.assign({}, navigatorOptions, { keyboardHandlingEnabled: false, screenOptions: screenOptions, children: currentScreens.map(screen => (_jsx(Navigation.Screen, Object.assign({}, screen), screen.name))) })));
});
